import {
    IBS_FETCH,
    IBS_FETCH_ALL,
    IBS_IS_FETCING,
    IB_FILTER,
    IB_EDIT,
} from 'constants/ibs'

export default function ibsReducer(state = {
    list: [],
    pageable: {
        sort: {
            'ibId': false,
            'name': 'asc',
            'email': false,
            'address': false,
            'description': false,
        },
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case IBS_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case IBS_FETCH_ALL:
            return {
                ...state,
                list: action.payload,
            }
        case IB_EDIT:
            return {
                ...state,
                // list: state.list.find(e=>state.ibId===e.ibId)?,
            }
        case IBS_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        case IB_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ibs.js